import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentDocumentCollectionPage() {
  return (
    <LatamAgentPage locale="es-CO" agentKey="document_collection_and_filing" />
  );
}
